// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"7774aa2f","187":"37294dbc","652":"b2e3d1c8","917":"803f1c77"}[chunkId] + ".chunk.js";
};